<template>
  <div class="simpleList">
    <div style="font-weight: bold;">{{simpleList.listHeader.heading}}</div>
    <div>{{simpleList.listHeader.subheading}}</div>
    <div v-for="(fileMini, current) in simpleList.fileMinis" :key="current">
      <File :file="fileMini" @navigated="$emit('navigated')" />
      <span>&#160;</span>
      <span style="color: gray;">{{fileMini.categoryCode}}</span>
    </div>
  </div>
</template>

<script>
import File from "@/components/link/File";
export default {
  name: "SimpleList",
  components: {
    File
  },
  props: {
    simpleList: null
  }
};
</script>
